/* Shopify is authoritative for prices, variant availability and order quantities. */
(() => {
  'use strict';
  const form = document.querySelector('#mistmove-product-form');
  if (!form) return;
  const price = document.querySelector('#set-price');
  const status = document.querySelector('#set-price-status');
  const select = document.querySelector('#pack-variant');
  const quantity = document.querySelector('#set-quantity');
  const button = document.querySelector('#add-to-cart');
  const shopNow = document.querySelector('#shop-now');
  const feedback = document.querySelector('#cart-feedback');
  const radios = [...document.querySelectorAll('[name=set]')];
  const records = [...document.querySelectorAll('[data-pack-price]')].map(el => el.dataset);
  if (!price || !status || !select || !quantity || !button || !feedback) return;
  let busy = false;
  let uncertain = false;
  function selection() {
    const count = document.querySelector('[name=set]:checked')?.value;
    const candidates = records.filter(record => record.packPrice === count);
    if (candidates.length !== 1) return null;
    const record = candidates[0];
    const cents = Number(record.priceCents);
    if (!/^\d+$/.test(record.variantId || '') || !/^\d+$/.test(record.priceCents || '') || !Number.isSafeInteger(cents) || cents < 0 || !record.priceLabel?.trim() || record.requiresSellingPlan === 'true') return null;
    if (records.filter(item => item.variantId === record.variantId).length !== 1) return null;
    return record;
  }
  function positive(value, fallback = 1) {
    const n = Number(value);
    return Number.isSafeInteger(n) && n > 0 ? n : fallback;
  }
  function render(resetQuantity = false) {
    const record = selection();
    feedback.textContent = '';
    if (!record) {
      select.value = '';
      price.textContent = 'Price pending Shopify setup';
      status.textContent = 'This set is not currently configured for purchase.';
      button.disabled = true;
      if (shopNow) shopNow.disabled = true;
      button.textContent = 'Currently unavailable';
      return;
    }
    select.value = record.variantId;
    price.textContent = record.priceLabel;
    const minimum = positive(record.quantityMin);
    quantity.min = String(minimum);
    quantity.step = String(positive(record.quantityIncrement));
    const maximum = positive(record.quantityMax, 0);
    if (maximum) quantity.max = String(maximum); else quantity.removeAttribute('max');
    if (resetQuantity) quantity.value = String(minimum);
    status.textContent = record.available === 'true' ? 'Available. Stock is confirmed by Shopify when added to your cart.' : 'Currently unavailable in Shopify.';
    button.disabled = busy || uncertain || record.available !== 'true';
    if (shopNow) shopNow.disabled = button.disabled;
    button.textContent = busy ? 'Adding…' : uncertain ? 'Check your cart' : record.available === 'true' ? 'Add to cart' : 'Currently unavailable';
  }
  radios.forEach(radio => radio.addEventListener('change', () => render(true)));
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || uncertain) return;
    const record = selection();
    if (!record || record.available !== 'true') { render(); return; }
    if (!form.reportValidity()) return;
    const amount = Number(quantity.value);
    const min = positive(record.quantityMin);
    const step = positive(record.quantityIncrement);
    const max = positive(record.quantityMax, 0);
    if (!Number.isSafeInteger(amount) || amount < min || (amount - min) % step !== 0 || (max && amount > max)) {
      feedback.textContent = 'Please enter a valid number of sets.';
      quantity.focus();
      return;
    }
    const directCheckout = shopNow && event.submitter === shopNow;
    busy = true;
    if (shopNow) {
      shopNow.disabled = true;
      shopNow.textContent = directCheckout ? 'Opening checkout…' : 'Shop Now';
    }
    button.disabled = true;
    button.textContent = 'Adding…';
    quantity.disabled = true;
    radios.forEach(radio => { radio.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    feedback.textContent = '';
    try {
      // amount is the number of full sets, NEVER the number of bottles in a set.
      const response = await fetch(form.action + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: record.variantId, quantity: amount}]})
      });
      const data = await response.json();
      if (!response.ok || data.status || !Array.isArray(data.items) || data.items.length !== 1 || String(data.items[0].variant_id ?? data.items[0].id) !== record.variantId) {
        const detail = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'Shopify could not confirm this addition.';
        throw new Error(/\p{Script=Han}/u.test(detail) ? 'Shopify could not add this set. Please check the available quantity.' : detail);
      }
      uncertain = true; // Block duplicate submits while navigation is pending.
      window.location.assign(directCheckout ? shopNow.value : form.dataset.cartUrl);
    } catch (error) {
      // An interrupted request (and some inventory errors) may already have added stock.
      // Never auto-retry and risk duplicating a customer's set.
      uncertain = true;
      const message = error instanceof Error ? error.message : 'The request could not be confirmed.';
      feedback.textContent = message + ' Please view your cart before trying again.';
      feedback.focus();
      button.textContent = 'Check your cart';
      if (shopNow) shopNow.textContent = 'Check your cart';
    } finally {
      busy = false;
      form.removeAttribute('aria-busy');
      button.disabled = true; // Navigation or cart review is required after any submitted request.
      if (shopNow) shopNow.disabled = true;
    }
  });
  document.querySelector('#native-variant-picker').hidden = true;
  document.querySelector('#pack-radios').hidden = false;
  render(true);
  // Re-fetch server-rendered price/stock when returning from cart via bfcache.
  window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
})();
